import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ss-totalizador" }
const _hoisted_2 = { class: "ss-totalizador-titulo" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ss-totalizador-simbolo" }, "R$", -1)
const _hoisted_5 = { class: "ss-totalizador-valor" }
const _hoisted_6 = {
  key: 1,
  class: "ss-totalizador-valor"
}
const _hoisted_7 = {
  key: 2,
  class: "ss-totalizador-valor"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.props.titulo), 1),
    (_ctx.props.monetario)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.props.valor,_ctx.props.casasDecimais, false, true)), 1)
        ]))
      : (_ctx.props.casasDecimais > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.props.valor,_ctx.props.casasDecimais, false, true)), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.UtilitarioMascara.mascararNumeroInteiro(_ctx.props.valor)), 1))
  ]))
}